/* eslint-disable no-shadow */
import axiosUserInstance from '@/helpers/http-common';

const state = () => ({
  contestGroups: null,
  timestamp: null,
  loadingContests: false,
});

// getters
const getters = {
};

  // actions
const actions = {
  init({ commit, dispatch }) {
    const cachedContestGroups = JSON.parse(localStorage.getItem('contestGroups'));

    if (cachedContestGroups && new Date() <= cachedContestGroups.timestamp) {
      commit('updateContestGroups', { contestGroups: cachedContestGroups.contestGroups, timestamp: cachedContestGroups.timestamp });
    } else {
      // expired or missing tiers
      dispatch('fetchContestGroups');
    }
  },
  loadContestGroups({ state, dispatch }) {
    if (!state.contestGroups || !state.timestamp) {
      dispatch('init');
    } else if (new Date() > state.timestamp) {
      // expired tiers
      dispatch('fetchContestGroups');
    }
  },
  fetchContestGroups({ commit }) {
    commit('loadingContests', true);

    axiosUserInstance.get('contests/show')
      .then((response) => {
        const currentDate = new Date();
        const expirationCacheDate = currentDate.setTime(
          // eslint-disable-next-line comma-dangle
          currentDate.getTime() + (12 * 60 * 60 * 1000)
        );

        localStorage.setItem('contestGroups', JSON.stringify({ contestGroups: response.data.contestGroups, timestamp: expirationCacheDate }));
        commit('updateContestGroups', { contestGroups: response.data.contestGroups, timestamp: expirationCacheDate });
      })
      .catch(() => {
        throw new Error('Αποτυχία φόρτωσης διαγωνισμών.');
      });
  },
  removeContests(
    { commit },
  ) {
    localStorage.removeItem('contestGroups');

    commit('removeContests');
  },
};

  // mutations
const mutations = {
  loadingContests(state, loadingContests = true) {
    state.loadingContests = loadingContests;
  },
  updateContestGroups(state, { contestGroups, timestamp }) {
    state.contestGroups = contestGroups;
    state.timestamp = timestamp;
    state.loadingContests = false;
  },
  removeContests(state) {
    state.contestGroups = null;
    state.timestamp = null;
    state.loadingContests = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/userContests.js